import type { ITicketConveyancingLoanDetails } from './TicketConveyancingLoanDetails.interface';

export default class TicketConveyancingLoanDetails implements ITicketConveyancingLoanDetails {
  lender: string;

  static build = (data: ITicketConveyancingLoanDetails) =>
    new TicketConveyancingLoanDetails(data);

  static blank = () => new TicketConveyancingLoanDetails();

  /**
   * Constructor
   * @param {ITicketConveyancingLoanDetails} data
   */
  constructor(data?: ITicketConveyancingLoanDetails) {
    this.lender = data?.lender || '';
  }
}
